// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__DR2PQ","obliqueLineWrap":"membershipbadge_obliqueLineWrap__W88zn","obliqueLine":"membershipbadge_obliqueLine__3caBR"};